import { GiSlingshot } from "react-icons/gi"

export const siteConfig = {
    // Basic site info
    name: "Da Wae",
    title: "Da Wae",
    description: "Nevah stop clicking! We must find da wae!",

    // Add content section for reusable text
    content: {
        hero: {
            title: "Do You Know Da Wae?",
            subtitle: "Nevah stop clicking! We must find da wae!",
            buttonText: "Show Me Da Wae"
        },
        about: {
            title: "About Da Wae",
            description: "Nevah stop clicking! We must find da wae!"
        },
        coingecko: {
            url: "#",
            description: "Track $DAWAE price on CoinGecko"
        },
        wiki: {
            url: "https://weykipedia.fandom.com/wiki/Special:AllPages",
            buttonText: "Visit Da Wiki"
        },
        memes: {
            title: "Ugandan Gallery",
            description: "Ugandan memes"
        },
        footer: {
            copyright: "© 2026 Da Wae. All Ebola reserved.",
            description: "Nevah stop clicking! We must find da wae!"
        }
    },

    // Contract info
    contract: {
        description: "Ugandan Knuckles is back on Solana. Join $DAWAE!",
        chains: [
            {
                chainId: "solana",
                name: "Solana",
                address: "BGjQfjXFf9wVwrmVeaMnmzsgzpbJEAkarjzj3pshpump",
                icon: "/icons/solana-icon.svg"
            },

        ]
    },

    // Contact info
    contact: {
        email: "info.dawae@gmail.com"
    },

    // Social links
    socials: {
        telegram: "https://t.me/douknodawae",
        telegram_channel: "#",
        twitter: "https://x.com/i/communities/2029952574858650005",
        twitter_community: "https://x.com/i/communities/2029952574858650005",
        TikTok: "https://www.tiktok.com/@dawae_official",
    },

    // Trading links (Pump.fun link - update URL after launching the coin if needed)
    trading: {
        Pumpfun: "https://pump.fun/coin/BGjQfjXFf9wVwrmVeaMnmzsgzpbJEAkarjzj3pshpump",
        Chart: "https://dexscreener.com/solana/cwsqjqouxmiyfmfnnvrtgbu6hwodbehhvymjwfgtj5av",
    },

    // Navigation links
    navigation: [
        { name: "About", href: "#about" },
        { name: "Buy now", href: "#buy" },
        { name: "Memes", href: "#memes" },
        { name: "PFP Studio", href: "/pfp-studio" },
        { name: "Banner Studio", href: "/banner-studio" },
        { name: "3D Spoilers", href: "/models" },
        { name: "Community", href: "#community" },
    ],

    // Assets paths
    assets: {
        logo: "/ugandan-knuckles.png",
        introVideo: {
            src: "/videos/ugandan-intro.MP4",
            type: "video/mp4",
            poster: "/images/intro-thumbnail.png"
        },
        coingecko: "/icons/coingecko-variant-white.svg"
    }
}

const { socials, trading } = siteConfig
export const socialsLinks = [
    /*   {
          title: "Telegram Channel",
          icon: "FaTelegram",
          url: socials.telegram_channel,
      }, */
    {
        title: "Twitter",
        icon: "FaTwitter",
        url: socials.twitter,
    },
    {
        title: "TikTok",
        icon: "tiktok",
        url: socials.TikTok,
    },

    {
        title: "Telegram Group Chat",
        icon: "FaUsers",
        url: socials.telegram,
    }
]


export const tradingLinks = [
    {
        title: "Buy Now",
        icon: "pumpfun",
        url: trading.Pumpfun,
    },
    {
        title: "Chart",
        icon: "FaChartLine",
        url: trading.Chart,
    },
    /* {
        title: "Photon",
        icon: "photon",
        url: trading.Photon,
    } */,
    /*  {
         title: "Buy on SlingShot",
         icon: "slingshotBlack",
         url: trading.SlingShot,
     } */
]